<template>
  <div class="tabs-filter-box">
    <el-form
      ref="levelRightsFilterRef"
      class="search-form"
      :inline="true"
      :model="form"
      @keyup.native.enter="handleSearch"
    >
      <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
        <el-col :span="6">
          <el-form-item label="起止日期">
            <el-date-picker
              v-model="form.dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div class="search-btns">
            <!-- <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div> -->
            <div class="form-btns">
              <el-button class="form-btn" @click.native.prevent="handleBack">
                返 回
              </el-button>
              <el-button
                class="form-btn"
                type="primary"
                @click.native.prevent="handleSearch"
              >
                查 询
              </el-button>
              <!-- <el-button class="form-btn" @click.native.prevent="handleExport">
                导 出
              </el-button> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

export default {
  name: 'ListFilter',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      openMore: false,
      loading: false,
      options: [],
      controlTypeOptions: [
        { label: '全部', value: '' },
      ],
      controlStatusOptions: [
        { label: '全部', value: '' },
      ],
    };
  },
  methods: {
    handleSearch() {
      this.$emit('search');
    },
    handleReset() {
      this.$emit('reset');
    },
    handleExport() {
      this.$emit('export');
    },
    handleBack() {
      this.$emit('back');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-btns {
  float:right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #06b880 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 5px 0;
    .el-form-item {
      width: 100%;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
